import api from './api';

export interface AdminReview {
    id: string;
    productId: string;
    productTitle: string;
    userId: string;
    userName: string;
    rating: number;
    comment: string;
    status: 'approved' | 'inactive';
    createdAt: string | null;
}

export const reviewsApi = {
    async getReviews(params?: { status?: string; productId?: string }): Promise<AdminReview[]> {
        try {
            const response = await api.get('/admin/reviews', { params });
            return response.data.reviews || [];
        } catch (error: any) {
            console.error('Error fetching reviews:', error);
            throw new Error(error.response?.data?.error || 'Yorumlar yüklenemedi');
        }
    },

    async updateStatus(reviewId: string, status: 'approved' | 'inactive'): Promise<void> {
        try {
            await api.put(`/admin/reviews/${reviewId}/status`, { status });
        } catch (error: any) {
            console.error('Error updating review status:', error);
            throw new Error(error.response?.data?.error || 'Yorum güncellenemedi');
        }
    },

    async deleteReview(reviewId: string): Promise<void> {
        try {
            await api.delete(`/admin/reviews/${reviewId}`);
        } catch (error: any) {
            console.error('Error deleting review:', error);
            throw new Error(error.response?.data?.error || 'Yorum silinemedi');
        }
    },
};
